import { memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import usePopUp from 'src/hook/modal/usePopUp';
import { useLearning } from '../../../../../hook/data/useLearning';
import { Actions } from '../../../../../model/enum/enums';
import { Word } from '../../../../../model/Word';
import styles from './ButtonSection.module.scss';


export const ButtonSection = memo(({ word }: { word: Word }) => {
    const { t } = useTranslation();
    const { shouldLearn, alreadeyKnew, unDecided, learningInfo } = useLearning();
    const [existWord, setExistWord] = useState<string | null>(null);
    const popup = usePopUp();

    useEffect(() => {
        if (!learningInfo || existWord !== null) {
            return;
        }
        const isKnown = learningInfo.KnownWordIds.includes(word.ID);
        const isToLearn = learningInfo.ToLearn.includes(word.ID);
        const isUnknown = !isToLearn && learningInfo.UnknownWordIds.includes(word.ID);
        ;

        if (isKnown) setExistWord(Actions.Knew);
        else if (isToLearn) setExistWord(Actions.Learn);
        else if (isUnknown) setExistWord('unknown');
        else setExistWord('');
    }, [word.ID, learningInfo, existWord]);


    const handleShouldLearn = useCallback(() => {
        setExistWord(Actions.Learn);
        shouldLearn(word);
    }, [word, shouldLearn]);

    const handleAlreadyKnew = useCallback(() => {
        setExistWord(Actions.Knew);
        alreadeyKnew(word);

    }, [word, alreadeyKnew]);

    const handleContinue = useCallback(() => {
        // if (existWord === 'unknown') {
        //     popup.show({
        //         title: word.Text[0].toUpperCase() + word.Text.slice(1),
        //         message: t('You first learnt about it 4 months ago.\n You\'ve remembered it once.'),
        //         primaryButtonText: t('OK'),
        //     });
        //     return;
        // }
        setExistWord('');
        unDecided(word);
    }, [word, unDecided]);


    if (existWord === null) return null;

    return existWord === '' ? (
        <section className={styles.buttonSection}>
            <button onClick={handleShouldLearn}>{t('Should learn')}</button>
            <button onClick={handleAlreadyKnew} className='turquoiseButton'>{t('Already knew')}</button>
        </section>
    ) : (
        <section
            onClick={handleContinue}
            className={`${styles.styledButton} ${existWord ===
                Actions.Knew ? styles.knew :
                existWord === Actions.Learn ? styles.learn :
                    styles.learning}`}
        >
            {existWord === Actions.Knew ? t('Already Knew')
                : existWord === Actions.Learn ? t('Should Learn')
                    : t('Learning')}{'\u00A0'} ▼
        </section>
    );
});

